import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranDemarrage } from './EcranDemarrage.js';

/** Écran du lot L64, lu par `import.meta.glob('../features/*\/index.{ts,tsx}')` de la coquille. */
export const ecrans: Readonly<Record<string, ComposantEcran>> = { D17: EcranDemarrage };
